import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { AppError, MessageService } from "@obg/ngx.core";
import { merge, of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

import { LOYALTY_CONTENT_ACTION_TYPE, LoyaltyContentAction } from "./loyalty-content.action";
import { loyaltyContentMessageContext } from "./loyalty-content.const";
import { LoyaltyContentService } from "./loyalty-content.service";

@Injectable()
/**
 * @deprecated [fabric-deprecated] - Use event bus retrieve with AccountAppValue instead
 */
export class LoyaltyContentEffect {
	/**
	 * @deprecated [fabric-deprecated] - Use event bus retrieve with AccountAppValue.GetLoyaltyContentMemberLevels instead
	 */
	getMemberLevels$ = createEffect(() =>
		this.actions$.pipe(
			ofType(LOYALTY_CONTENT_ACTION_TYPE.getMemberLevels),
			switchMap(() =>
				this.service.getMemberLevels().pipe(
					map((response) => this.action.getMemberLevelsSuccess(response)),
					catchError((error: AppError) => of(this.action.getMemberLevelsFail(error)))
				)
			)
		)
	);
	/**
	 * @deprecated [fabric-deprecated] - Use event bus retrieve with AccountAppValue.GetLoyaltyContentEarnPoints instead
	 */
	getEarnPoints$ = createEffect(() =>
		this.actions$.pipe(
			ofType(LOYALTY_CONTENT_ACTION_TYPE.getEarnPoints),
			switchMap(() =>
				this.service.getEarnPoints().pipe(
					map((response) => this.action.getEarnPointsSuccess(response)),
					catchError((error: AppError) => of(this.action.getEarnPointsFail(error)))
				)
			)
		)
	);
	/**
	 * @deprecated [fabric-deprecated] - Use event bus retrieve with AccountAppValue instead
	 */
	initMessages$ = createEffect(() =>
		merge(
			this.messageService.mapErrorByContext$({
				[LOYALTY_CONTENT_ACTION_TYPE.getMemberLevelsFail]: loyaltyContentMessageContext.getMemberLevels,
				[LOYALTY_CONTENT_ACTION_TYPE.getEarnPointsFail]: loyaltyContentMessageContext.getEarnPoints,
			}),
			this.messageService.mapClearByContext$({
				[LOYALTY_CONTENT_ACTION_TYPE.getMemberLevels]: loyaltyContentMessageContext.getMemberLevels,
				[LOYALTY_CONTENT_ACTION_TYPE.getEarnPoints]: loyaltyContentMessageContext.getEarnPoints,
			})
		)
	);

	constructor(
		private action: LoyaltyContentAction,
		private actions$: Actions,
		private service: LoyaltyContentService,
		private messageService: MessageService
	) {}
}
